/**
 * Rechtstexte und Kontaktwege - an einer Stelle.
 *
 * Sie liegen auf der Marketing-Seite und nicht in der App: eine zweite Fassung
 * in der App waere eine zweite Wahrheit, und zwar die, die niemand pflegt.
 */
export const LEGAL_URLS = {
  agb: 'https://melowish.com/agb/',
  datenschutz: 'https://melowish.com/datenschutz/',
  impressum: 'https://melowish.com/impressum/',
} as const;

/** Wohin ein Widerruf geht. */
export const KONTAKT_MAIL = 'info@melowish.com';
export const KONTAKT_FORMULAR = 'https://melowish.com/kontakt/';

/** Anbieter, wie er in Einwilligungen genannt wird. */
export const ANBIETER = 'edwaco eGbR, Boschstraße 1A, 30916 Isernhagen';
